import { render, staticRenderFns } from "./SurveyBuilderRating.vue?vue&type=template&id=27b07ffc&scoped=true"
import script from "./SurveyBuilderRating.vue?vue&type=script&lang=js"
export * from "./SurveyBuilderRating.vue?vue&type=script&lang=js"
import style0 from "./SurveyBuilderRating.vue?vue&type=style&index=0&id=27b07ffc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b07ffc",
  null
  
)

export default component.exports